import { render, staticRenderFns } from "./TrainingVideoList.vue?vue&type=template&id=62b56344&"
import script from "./TrainingVideoList.vue?vue&type=script&lang=js&"
export * from "./TrainingVideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports